import JobContentCheckout from './components/Checkout';
import JobContentQuote from './components/Quote';
import { useJobContext } from './context';

const JobContent: React.FunctionComponent = function () {
  const { page } = useJobContext();
  switch (page) {
    case 'QUOTE':
      return <JobContentQuote />;
    case 'CHECKOUT':
      return <JobContentCheckout />;
    case 'COMPLETE':
      return <div>Complete</div>;
    default:
      return <div>Error</div>;
  }
};

export default JobContent;
